export function getNextDayStart(): string {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    tomorrow.setHours(0, 0, 0, 0)
    return tomorrow.toISOString()
}

export function getNextWeekStart(weekStartDay = 1): string {
    const now = new Date()
    const currentDay = now.getDay()
    let daysUntilNext = weekStartDay - currentDay
    if (daysUntilNext <= 0) daysUntilNext += 7
    const nextWeek = new Date(now)
    nextWeek.setDate(now.getDate() + daysUntilNext)
    nextWeek.setHours(0, 0, 0, 0)
    return nextWeek.toISOString()
}

export function getMaxPauseDate(): Date {
    const max = new Date()
    max.setMonth(max.getMonth() + 1)
    max.setHours(0, 0, 0, 0)
    return max
}

export function isTrackingPaused(pausedUntil: string | null): boolean {
    if (!pausedUntil) return false
    return new Date(pausedUntil) > new Date()
}

export function isPauseDateWithinLimit(date: string | null | undefined): boolean {
    if (!date) return true
    return new Date(date) <= getMaxPauseDate()
}

export function formatPauseDate(pausedUntil: string): string {
    return new Date(pausedUntil).toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    })
}
